ui-cms-quickfact-group {
  .quickfact-group {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
